import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Fab } from "@mui/material";
import { APP_BACKGROUND_COLOR,APP_COLOR } from "../../theme";

export const FloatingButton = styled(Fab)(({ theme }) => ({
  position: "fixed",
  backgroundColor: APP_COLOR,
  color: "white",
  right: "20px",
  bottom: "20px",
  "&:hover": {
    backgroundColor: APP_COLOR,
    color: "black",
  },
}));

export const ChatContainer = styled(Box)(({ theme }) => ({
  position: "fixed",
  zIndex: 10000,
  width: "400px",
  height: "80vh",
  right: "25px",
  bottom: "80px",
  backgroundColor: APP_BACKGROUND_COLOR,
  border: "1px gray solid",
  borderRadius: "2%",
  overflow: "scroll",
  padding: "2px",
  "&::-webkit-scrollbar": { display: "none" },
}));
